import { render, staticRenderFns } from "./fieldselector.vue?vue&type=template&id=5bc731ea&scoped=true"
import script from "./fieldselector.vue?vue&type=script&lang=js"
export * from "./fieldselector.vue?vue&type=script&lang=js"
import style0 from "./fieldselector.vue?vue&type=style&index=0&id=5bc731ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc731ea",
  null
  
)

export default component.exports